import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {fullDate} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';

class DispatchTurn extends Component {
  componentDidMount() {
    const {dealer, agency} = this.props;
    this.props.getDealerNextDispatchTurn(agency, dealer);
  }

  renderNextTurn() {
    const {loading, nextTurn} = this.props;

    if (loading) {
      return 'Consultando...';
    }

    const displayDate = nextTurn ? moment(nextTurn) : moment().add(1, 'days');
    return displayDate.format(fullDate);
  }

  render() {
    return (
      <React.Fragment>
        <strong>Próximo corte: </strong> {this.renderNextTurn()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'nextTurn': state.dealerStockOrders.nextDispatchTurn,
    'loading': state.dealerStockOrders.loadingDispatch,
  };
};

const {getDealerNextDispatchTurn} = Actions;

export default connect(mapStateToProps, {getDealerNextDispatchTurn})(DispatchTurn);
